import * as constants from './constants';
import axiosInstance from "../../../utils/request";
import { assembleQuery } from "../../../utils/query";


export const changeBuilds = (builds) => ({
    type: constants.CHANGE_BUILDS,
    builds
});

export const pagination = (params) => {
    return (dispatch) => {
        axiosInstance.get('/data/status?' + assembleQuery(params)
        ).then((response) => {
            let result = {
                list: response.data,
                page: response.page,
                perpage: response.perpage,
                total: response.total,
            };
            if (result) {
                dispatch(changeBuilds(result));
            }
        }).catch((e) => {
            return [];
        });
    }
}

export const find = (params= {}) => {
    // eslint-disable-next-line no-useless-concat
    return axiosInstance.get('/data/status' + '?' + assembleQuery(params)).then((response) => {
        return response.data;
    }).catch((e) => {
        return {};
    })
}

export const add = (data) => {
    let params = new FormData();
    for (let key in data) {
        if (data.hasOwnProperty(key)) {
            params.append(key, data[key]);
        }
    }
    return axiosInstance.post('/build', params);
}

export const latest = (params) => {
    let formData = new FormData();
    for (let key in params) {
        formData.append(key, params[key]);
    }
    return axiosInstance.post('/build_latest', formData);
}


export const cancel = (params) => {
    let formData = new FormData();
    for (let key in params) {
        formData.append(key, params[key]);
    }
    return axiosInstance.put('/task/cancel', formData).then((response) => {});
}

export const deleteBuild = (params = {}) => {
    const queryParams = {};
    for (let key in params) {
        if (!Object.prototype.hasOwnProperty.call(params, key)) {
            continue;
        }
        const value = params[key];
        if (value === undefined || value === null) {
            continue;
        }
        if (typeof value === 'string' && value.trim() === '') {
            continue;
        }
        queryParams[key] = value;
    }
    return axiosInstance.delete('/build?' + assembleQuery(queryParams));
}
